module.exports = __webpack_public_path__ + "static/img/11.c2ccd5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/11.jpg
// module id = Tp7Y
// module chunks = 0